
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import SurgirButton from "../../components/ui/SurgirButton/SurgirButton";
import SurgirCardProduct from "../../components/ui/SurgirCardProduct/SurgirCardProduct";
import Marcas1 from "./../../assets/images/safe/marcas-autos.png";
import bannerAuto from "./../../assets/images/safe/imagen auto.png";
import Marcas3 from "./../../assets/images/safe/Productos Auto nuevo logos marcas líderes 7.png";
import Marcas4 from "./../../assets/images/safe/Productos Auto nuevo logos marcas líderes 4.png";
import Marcas5 from "./../../assets/images/safe/Productos Auto nuevo logos marcas líderes 5.png";
import Marcas6 from "./../../assets/images/safe/Productos Auto nuevo logos marcas líderes 6.png";
import { useNavigate } from "react-router-dom";
import { PLANS, TABLE_PLANS, OPERATIONS, COVERAGE } from "./Safe.fixture";

import "./Safe.scss";

import {
  Container,
  Tabs,
  Tab,
  Table,
  Accordion,
} from "react-bootstrap";

import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { AlignType } from "react-bootstrap/esm/types";
import SurgirBanner from "components/ui/SurgirBanner/SurgirBanner";
import SurgirTabsResponsive from "components/ui/SurgirTabsResponsive/SurgirTabsResponsive";
import { width } from "@mui/system";


const titleSectionPlans = "Elige tu plan ideal";

const Safe: React.FC = () => {
  const navigate = useNavigate();

  const requestCredit = () => {
    const url = process.env.REACT_APP_MARCAS_DE_VEHICULOS;

  // Verificar si la URL está definida
  if (!url) {
    console.error('La URL no está definida.');
    return;
  }

  // Abrir la URL en una nueva pestaña para iniciar la descarga
  window.open(url, '_blank');

  // Desplazarse al principio de la página
  window.scrollTo(0, 0);
  };
  const requestSimulator = () => {
    const url = process.env.REACT_APP_SIMULADOR;

  // Verificar si la URL está definida
  if (!url) {
    console.error('La URL no está definida.');
    return;
  }

  // Abrir la URL en una nueva pestaña para iniciar la descarga
  window.open(url, '_blank');

  // Desplazarse al principio de la página
  window.scrollTo(0, 0);
  };
  const requestContact = () => {
    navigate("/contactanos");
    window.scrollTo(0, 0);
  };

  const [tablePlanVisible, setTablePlanVisible] = useState(false);
  const [showCardsCoverage, setShowCardsCoverage] = useState(6);


  const useMediaQuery = (query: any) => {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      const listener = () => setMatches(media.matches);
      window.addEventListener('resize', listener);
      return () => window.removeEventListener("resize", listener)
    }, [matches, query]);

    return matches;
  }

  const mobile = useMediaQuery('(max-width: 575px)');
  const isTabletSm = useMediaQuery('(min-width: 576px) and (max-width: 767px)');
  const isTabletMd = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
  const isTabletLg = useMediaQuery('(min-width: 992px) and (max-width: 1199px)');


  const styleCardsPlans = (index: any) => {

    if (index === 0) {
      return 'section-plans__cards__first';
    }

    return index === 1 ? 'section-plans__cards__second' : 'section-plans__cards__thirth'
  }

  const [faqVisible, setFaqVisable] = useState(false)

  const tabsResponsive = [
    {
      title: 'Requisitos',
      body: (
        <div className="section-information__tabs__tab-requirements">
          <span>Persona Natural:</span>
          <ul>
            <li>DNI o Carnet de Extranjería</li>
            <li>Recibo de servicios donde aparezca tu dirección (recibo de luz, agua, etc)</li>
            <li>Documento donde se vean tus ingresos o capacidad de pago (boleta de pago, recibos, PDT u otros) (*)</li>
          </ul>
          <span>(*) Es posible que más adelante se te pidan otros documentos</span>
          <p>Por el momento no estamos trabajando con personas jurídicas, ¡pero próximamente lo haremos! </p>
        </div>
      )
    },
   
    {
      title: 'Preguntas frecuentes',
      body: (
        <div className="section-information__tabs">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              ¿Qué es un Sistema de Administración de Fondo Colectivo?
            </Accordion.Header>
            <Accordion.Body>
              Es una modalidad que permite a las personas naturales y/o jurídicas participar de un fondo colectivo a través de sus aportes periódicos en dinero (cuotas mensuales), con la finalidad de adquirir bienes (inmuebles, automóviles, motos, maquinaria y equipo) y/o servicios que autorice la Superintendencia del Mercado de Valores (SMV).
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              ¿Qué es un Programa?
            </Accordion.Header>
            <Accordion.Body>
              Los Programas contienen información relevante para el Asociado acerca del marco general y las características aplicables a los Grupos formados (los grupos están conformados por un número determinado de Asociados que participan de un fondo colectivo, en virtud de sus contratos). Deben ser presentados a la SMV para su autorización.
              <br />Los Programas deben estar a disposición del público en general, siendo obligación de las Empresas Administradoras de Fondos Colectivos (EAFC) difundirlos permanentemente a través de su página web.
              <br />Dentro de la información relevante que debe incorporar el programa, cabe mencionar la siguiente:

              <ul>
                <li>• Las modalidades para la adquisición de los bienes y/o servicios.</li>
                <li>• La descripción de los bienes y/o servicios que serán adquiridos para los Asociados que integren los grupos que se formen bajo el Programa.</li>
                <li>• El plazo de duración del Grupo y la periodicidad de las Asambleas.</li>
                <li>• El número teórico de Asociados que conformarán el Grupo y el número de adjudicaciones por Asamblea.</li>
                <li>• El porcentaje y periodicidad de cobro de las cuotas de inscripción, administración y capital.</li>
                <li>• La política de garantías (la política de garantías debe especificar las garantías reales y personales que serán admitidas por la EAFC, así como la cobertura mínima respecto del monto adeudado por el Asociado) y las causales para su ejecución.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              ¿Qué es un Contrato?
            </Accordion.Header>
            <Accordion.Body>
              El Contrato de Administración de Fondos Colectivos regula las relaciones entre los Asociados y las EAFC, precisando los deberes y obligaciones de ambas partes. El(los) modelo(s) de contrato(s) que utilizará(n) la EAFC debe(n) ser presentado(s) a la SMV juntamente con la solicitud de autorización del(los) Programa(s) correspondiente(s). Dentro de la información relevante que debe incorporar el Contrato, cabe mencionar la siguiente:
              <ul>
                <li>• Las características del Programa bajo el cual se conforma el Grupo.</li>
                <li>• Las modalidades y procedimientos de adjudicación.</li>
                <li>•	Las características principales de los bienes o servicios que podrán ser adquiridos en el marco del Contrato, y los requisitos y plazos para su entrega. </li>
                <li>• Las garantías y seguros que se exigirán al Asociado para la entrega del bien y/o la prestación del servicio adjudicado.</li>
                <li>• El detalle de las cuotas y gastos que debe abonar el Asociado.</li>
                <li>• Medidas ante el incumplimiento de pagos.</li>
                <li>• Causales de resolución del Contrato.</li>
                <li>• Las condiciones para la cesión de posición contractual.</li>
                <li>• Las penalidades que se pacten.</li>
                <li>• Cláusula mediante la cual el Asociado declara su sometimiento a las normas que dicte la SMV.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              ¿Qué es la Cartilla para el Asociado?
            </Accordion.Header>
            <Accordion.Body>
              La Cartilla para el Asociado describe en términos sencillos los aspectos más importantes de un Sistema de Fondos Colectivos. En este ámbito, Las EAFC tienen la obligación de entregar la Cartilla a los potenciales Asociados con anterioridad a su firma del Contrato de administración de fondos colectivos, la Cartilla explica en un formato de preguntas y respuestas:
              <ul>
                <li>• ¿Qué es un Sistema de Fondos Colectivos?</li>
                <li>• ¿Cómo se adquiere la calidad de Asociado?</li>
                <li>• ¿Qué pagos efectúa el Asociado a la EAFC por el servicio que le brinda?</li>
                <li>• ¿Cómo se adquiere el derecho de adjudicación?</li>
                <li>• ¿Cuál es la condición para la entrega del bien y/o servicio adjudicado?</li>
                <li>• ¿Qué sucede si el Asociado incumple con los pagos de las cuotas establecidas en el Contrato? </li>
                <li>• ¿Quién supervisa y controla a las EAFC?</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              ¿Qué incorpora el Tarifario?
            </Accordion.Header>
            <Accordion.Body>
              En el tarifario se incorporan los cobros de las EAFC por los servicios adicionales que brindan a los Asociados, distintos de los cubiertos por la cuota de Ad-ministración o por la cuota de Inscripción.
              <br />Las EAFC tienen la obligación de entregar el tarifario a los potenciales Asociados con anterioridad a su firma del Contrato de Administración de Fondos Colectivos. Sin perjuicio de ello, deberán exhibirse en lugares visibles y estar a disposición del público en general en las oficinas de las EAFC en folletos u hojas impresas.

            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              ¿Qué es un Certificado de compra?
            </Accordion.Header>
            <Accordion.Body>
              Es un documento que representa el derecho del Asociado a la aplicación del importe que se consigna en él para la adquisición del bien y/o servicio.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>
              ¿Qué es la Cuota de Inscripción?
            </Accordion.Header>
            <Accordion.Body>
              Es el importe que el Asociado paga por única vez a la EAFC por el derecho de ingreso a un Grupo y por cada Contrato del que sea titular.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>
              ¿Qué es la Cuota Total?
            </Accordion.Header>
            <Accordion.Body>
              Es el importe que el Asociado paga de forma periódica a la EAFC y que comprende, a su vez, los siguientes conceptos:
              <ul>
                <li>• Cuota Capital: Monto destinado exclusivamente a cubrir el valor del bien y/o servicio materia del Contrato.</li>
                <li>• Cuota de Administración: Monto que se paga a las EAFC por el servicio de administración de Fondos Colectivos.</li>
                <li>• Cuota de Seguro: Monto que se paga por seguro de desgravamen, seguro de vida o cualquier otro riesgo asegurable vinculado al Contrato, como el seguro vehicular, siempre que el Programa y el Contrato lo hayan establecido.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="8">
            <Accordion.Header>
              ¿Qué incorpora un Estado de Cuenta?
            </Accordion.Header>
            <Accordion.Body>
              La información mínima que debe incorporar el Estado de Cuenta es la siguiente:
              <ul>
                <li>• El valor del certificado de compra o bien y/o servicio determinado objeto del Contrato.</li>
                <li>• Fecha de la Asamblea Inaugural.</li>
                <li>• Fecha proyectada de finalización de grupo.</li>
                <li>• Número de cuotas a pagar, monto de la cuota mensual y número de cuotas pendientes de pago.</li>
                <li>• Estado y fecha de adjudicación.</li>
                <li>• Detalle de los pagos de cuotas.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="9">
            <Accordion.Header>
              ¿Quién convoca a una Asamblea?
            </Accordion.Header>
            <Accordion.Body>
              Las Asambleas son convocadas por la Administradora y se realizan con la participación de un notario a fin de adjudicar a los Asociados hábiles con Contratos no Adjudicados y, cuando corresponda, sortear la devolución de aportes a los Asociados con Contratos resueltos.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="10">
            <Accordion.Header>
              ¿Qué es una Adjudicación?
            </Accordion.Header>
            <Accordion.Body>
              La adjudicación es el mecanismo a través del cual el Asociado accede al derecho de obtener un bien y/o servicio o a un certificado de compra que será utilizado para la adquisición de un bien y/o servicio.<br /> Las adjudicaciones se dan en cada Asamblea y son de los siguientes tipos:
              <ul>
                <li>• Adjudicación por sorteo</li>
                <li>• Adjudicación por remate</li>
                <li>• Adjudicación anticipada</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="11">
            <Accordion.Header>
              ¿Cómo se adquiere el derecho de Adjudicación?
            </Accordion.Header>
            <Accordion.Body>
              Los asociados para ser adjudicados, es decir, acceder al derecho de adquisición del bien y/o servicio objeto del Contrato, deben estar al día en el pago de las cuotas, tener un contrato que aún no haya sido adjudicado y no encontrarse inhabilitado de acuerdo con lo establecido en el Contrato.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="12">
            <Accordion.Header>
              ¿Qué es una adjudicación por Sorteo?
            </Accordion.Header>
            <Accordion.Body>
              Es el mecanismo por el cual se elige al azar al Asociado que será adjudicado.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="13">
            <Accordion.Header>
              ¿Qué es una adjudicación por Remate?
            </Accordion.Header>
            <Accordion.Body>
              El Remate es la modalidad de adjudicación que consiste en formular propuestas de pago por adelantado de un número determinado y entero de Cuotas Capital o Cuotas Total.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="14">
            <Accordion.Header>
              ¿Qué es una Adjudicación Anticipada?
            </Accordion.Header>
            <Accordion.Body>
              Es un mecanismo por el cual se pueden efectuar adjudicaciones anticipadas de Certificados de Compra o bienes y/o servicios determinados. Para tal efecto, la Administradora, y/o su proveedor, otorgarán un financiamiento complementario significativo al Grupo, el mismo que podrá ser en bienes, servicios o en efectivo. Los intereses o gastos por dicho financiamiento no serán asumidos por el Fondo Colectivo ni por los asociados.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="15">
            <Accordion.Header>
              ¿Cómo presento mi remate?
            </Accordion.Header>
            <Accordion.Body>
              La propuesta de remate se registra a través de nuestra página web en la sección Propuesta de Remates. Tendrás que ingresar tus datos y podrás formular el adelanto de cuotas que prefieras. Esta propuesta será develada el día de tu asamblea con presencia de notario público.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="16">
            <Accordion.Header>
              ¿Cuántas cuotas debo rematar para adjudicar?
            </Accordion.Header>
            <Accordion.Body>
              La oferta es totalmente libre, no hay ni un mínimo ni un máximo requerido, ganan las más altas (quien adelante más cuotas), por lo que nadie puede asegurarle la adjudicación con un determinado número de cuotas.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="17">
            <Accordion.Header>
              ¿Cómo me entero de que salí adjudicado?
            </Accordion.Header>
            <Accordion.Body>
              Los resultados son publicados en la página web de Santander, luego de 24 horas de haberse llevado a cabo la asamblea.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="18">
            <Accordion.Header>
              ¿Qué debo hacer cuando salga adjudicado?
            </Accordion.Header>
            <Accordion.Body>
              Puedes comunicarte a nuestro número de Atención al Cliente  (01) 730 - 1077 para solicitar más información o espera recibir el correo electrónico por parte de la administradora, donde te indicarán los documentos requeridos para iniciar el proceso de adjudicación.
            </Accordion.Body>
          </Accordion.Item>



          {
            !faqVisible ? (
              <div className="section-information_tabs_link">
                <div className="section-information__tabs__link__body" onClick={() => setFaqVisable(true)} >
          <h6  >Ver más preguntas</h6>
          <span>
            <img src="icons/safe/chevron-down-sm.svg" alt="Place Holder" />
          </span>
        </div>
              </div>
            ) : (
              <div>
                <Accordion.Item eventKey="19">
                  <Accordion.Header>
                    ¿Con qué marcas de autos trabajan?
                  </Accordion.Header>
                  <Accordion.Body>
                    Trabajamos con todas las marcas, tenemos convenios con las marcas y dealers, quienes brindarán las características y precios del vehículo que elijas.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="20">
                  <Accordion.Header>
                    ¿Puedo adquirir un auto de mayor valor?
                  </Accordion.Header>
                  <Accordion.Body>
                    Sí se puede, existen dos opciones: una es ampliar el certificado antes de lograr la adjudicación, y la otra es pagar la diferencia al concesionario después de adjudicar.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="21">
                  <Accordion.Header>
                    ¿Luego de salir adjudicado, en cuánto tiempo me entregan el auto?
                  </Accordion.Header>
                  <Accordion.Body>
                    El plazo de entrega dependerá del concesionario donde se adquiera el vehículo y de que se cuente con todos los documentos requeridos.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="22">
                  <Accordion.Header>
                    ¿Qué documentos debo firmar para convertirme en Asociado?
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>• Características del Programa</li>
                      <li>• Contrato de Administración de Fondos Colectivos</li>
                      <li>• Solicitud de ingreso al Programa</li>
                      <li>• Cartilla para el Asociado</li>
                      <li>• Cronograma de Pagos</li>
                      <li>• Tarifario</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="23">
                  <Accordion.Header>
                    ¿Cómo puedo participar en las Asambleas?
                  </Accordion.Header>
                  <Accordion.Body>
                    Para participar debes encontrarte al día en el pago de tus cuotas y penalidades hasta un (01) día antes de la fecha de la Asamblea de tu Grupo, el no estar al día en el pago implica que no podrás participar en los sorteos y remates que se realicen en ella.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="24">
                  <Accordion.Header>
                    ¿Cómo puedo pagar la Cuota de Inscripción?
                  </Accordion.Header>
                  <Accordion.Body>
                    Puedes realizar el pago mediante el enlace de pago de IZIPAY que te será enviado desde el correo electrónico comunicacionesasociados@santanderffcc.com.pe
                    <br />También puedes realizarlo desde nuestra página web en la sección  <a
                      href="https://app-fondoscolectivos-pago-test.azurewebsites.net/#/login  "
                      target="_blank"
                      className="linkturquesa "
                      rel="noopener noreferrer"
                    >
                      Pago de Cuotas
                    </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="25">
                  <Accordion.Header>
                    ¿Cómo puedo pagar mis cuotas?
                  </Accordion.Header>
                  <Accordion.Body>
                    La primera cuota la debes realizar mediante el enlace de pago de IZIPAY que te será enviado por correo electrónico.
                    <br />Las siguientes cuotas las podrás realizar desde la ventanilla o la app del banco con los que tenemos convenio usando el servicio de recaudación de “Santander Fondos Colectivos” y tu código identificador (número de operación). La relación de dichos bancos la podrás revisar en la sección de  <a
                      href="/transparencia "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Transparencia                     </a>
                    de la web.
                    <br />También puedes realizar el pago desde nuestra página web, en la sección  <a
                      href="https://app-fondoscolectivos-pago-test.azurewebsites.net/#/login "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Pago de Cuotas
                    </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="26">
                  <Accordion.Header>
                    ¿Qué pasa si salgo como Suplente?
                  </Accordion.Header>
                  <Accordion.Body>
                    Los Asociados que hayan presentado su propuesta de remate en la Asamblea y no hayan sido adjudicados, pero que obtengan las propuestas más faltas quedarán como suplentes en caso de que alguno de los Asociados adjudicados titulares no complete el pago del remate en el plazo establecido.
                    <br />El orden de preferencia se determinará por el mayor número de cuotas rematadas
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="27">
                  <Accordion.Header>
                    ¿Cómo elijo mi vehículo?
                  </Accordion.Header>
                  <Accordion.Body>
                    El Asociado deberá comunicar a la EAFC la elección del bien y/o servicio de acuerdo con lo establecido en el Programa y en su Contrato. Además, deberá indicar el nombre del proveedor elegido, precio final y las características del bien y/o servicio a adquirir.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="28">
                  <Accordion.Header>
                    ¿Qué es un Aval?
                  </Accordion.Header>
                  <Accordion.Body>
                    Es una garantía personal, un aval es un respaldo que una persona concede a otra con el fin de asegurar el cumplimiento de una obligación financiera o contractual. Se establece que, si la persona que ha asumido el compromiso legal no puede cumplir con sus obligaciones, el avalista asumirá la responsabilidad.          </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="29">
                  <Accordion.Header>
                    ¿Qué sucede si el vehículo que elijo es de mayor valor que mi Certificado?
                  </Accordion.Header>
                  <Accordion.Body>
                    Cuando el valor del bien y/o servicio sea mayor que el valor del Certificado de Compra, el Asociado debe cubrir la diferencia.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="30">
                  <Accordion.Header>
                    ¿Qué sucede si el vehículo que elijo es de menor valor que mi Certificado?
                  </Accordion.Header>
                  <Accordion.Body>
                    Cuando el valor del bien adjudicado sea menor al Certificado de Compra, a elección del asociado, la diferencia se aplicará a:
                    <ul>
                      <li>• Cancelar las últimas cuotas pendientes de pago.</li>
                      <li>•	Reducir el importe de las Cuota Total. Esta reducción es el resultado de dividir el monto de la diferencia entre el valor del Certificado de Compra o el valor del bien determinado y el bien y/o servicio adquirido, entre el número total de cuotas pendientes de pago.</li>
                      <li>•	Pagar las cuotas devengadas al cubrir una vacante.</li>
                      <li>•	Cubrir los gastos para mejoras del bien y/o servicio hasta un máximo del diez por ciento (10%) del valor del Certificado de Compra o al valor del bien a la suscripción del Contrato.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="31">
                  <Accordion.Header>
                    ¿Qué documentos debo firmar una vez adjudicado?
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>• Comunicación de Adjudicación y Requisitos</li>
                      <li>• Contrato de Garantía Mobiliaria</li>
                      <li>• Escritura Pública de Constitución de Garantía Mobiliaria</li>
                      <li>• Pagaré</li>
                      <li>• Declaración Personal de Salud (DPS)</li>
                      <li>• Declaración Jurada de Uso de Vehículo</li>
                      <li>• Declaración Jurada de Licitud de Fondos</li>
                      <li>• Proforma de Seguro Vehicular</li>
                      <li>• Formato GPS</li>
                      <li>• Formato de Protección de Datos Personales</li>
                      <li>• Resumen Informativo</li>
                      <li>• Cronograma actualizado</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="32">
                  <Accordion.Header>
                    ¿Cuál es la ventaja de tener mi seguro de auto incluido en la cuota?
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>• Tu auto siempre estará protegido durante la vigencia de tu Certificado.</li>
                      <li>• Cuentas con el respaldo de las principales aseguradoras del país.</li>
                      <li>•	En caso de robo, al tener un seguro auto puedes recuperar el valor comercial del vehículo, cumpliendo con lo estipulado en la póliza vehicular</li>
                      <li>•	En caso de un siniestro puedes requerir la reparación de daños a tu vehículo y al contar con el mejor seguro de auto cuentas con cobertura en base a las condiciones preferentes de tu póliza. </li>
                      <li>•	Ya no te preocupas de tener que renovar tu póliza anualmente ni tener que pagarla por un año en forma adelantada.</li>
                      <li>•	Evitas pagos de comisión por estudio y endosos</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="33">
                  <Accordion.Header>
                    ¿Por qué tengo un seguro de desgravamen?
                  </Accordion.Header>
                  <Accordion.Body>
                    Es un seguro que cubre el pago de la deuda contraída con el fondo colectivo al que pertenezco, en caso de fallecimiento o invalidez total y permanente por accidente o enfermedad. Con ello, los herederos del asegurado se verán liberados de la obligación de pago del certificado.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="34">
                  <Accordion.Header>
                    ¿Cuál es el procedimiento en caso tenga un siniestro con mi vehículo?
                  </Accordion.Header>
                  <Accordion.Body>
                    Debes llamar a la Central de Atención de Emergencias de la Aseguradora con la que se contrató el seguro. Dicha central funciona las 24 horas los 365 días del año.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="35">
                  <Accordion.Header>
                    ¿Cuál es el procedimiento por seguir en caso de requerir aplicar al seguro de desgravamen?
                  </Accordion.Header>
                  <Accordion.Body>
                    Una vez ocurrido el siniestro, el familiar y/o contacto del cliente deberá realizar lo
                    siguiente:
                    <ul>
                      <li>•	Presentar una carta formal dirigida a Santander Empresa Administradora de Fondos Colectivos S.A. indicando lo ocurrido y solicitando la activación de Seguro de Desgravamen. Asimismo, consignar los datos de la persona de contacto.</li>
                      <li>•	Adjuntar a la carta una copia simple de la partida y/o acta de defunción.</li>
                      <li>•	Enviarla a través del formulario  <a
                        href="/contactanos "
                        className="linkturquesa "
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contáctanos                          </a>
                        que se encuentra en nuestra página web.</li>
                      <li>•	Santander Fondos Colectivos entregará esta documentación al bróker, quienes se comunicarán con el contacto y solicitarán los siguientes documentos, según sea el caso.</li>
                    </ul>
                    Para FALLECIMIENTO POR CAUSA NATURAL:
                    <ul>
                      <li>•	Formulario de Declaración del Siniestro proporcionado por la Compañía.</li>
                      <li>•	Copia simple del Documento de Identidad del Asegurado, de contar con el mismo</li>
                      <li>•	Copia simple del Acta de Defunción del Asegurado.</li>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Certificado de Defunción del Asegurado.
                      </li>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Informe médico del médico tratante en caso de fallecimiento por Enfermedad.
                      </li>
                      <li>•	Historia Clínica completa, foliada y fedateada del Asegurado, cuando la compañía lo requiera.
                      </li>
                    </ul>
                    Para FALLECIMIENTO POR ACCIDENTE:
                    <br />Adicional a los Documentos Sustentatorios, antes indicados, para la Cobertura de
                    <br />Fallecimiento por Causa Natural, deberán presentar los siguientes documentos:
                    <ul>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del Atestado Policial o Parte Policial, según corresponda.
                      </li>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del
                        Protocolo de necropsia que incluya el resultado de examen toxicológico y
                        dosaje etílico, en caso corresponda.
                      </li>
                    </ul>
                    Para INVALIDEZ TOTAL Y PERMANENTE POR ENFERMEDAD:
                    <ul>
                      <li>•	Formulario de Declaración del Siniestro proporcionado por la Compañía.</li>
                      <li>•	Copia simple del documento de identidad del Asegurado.</li>
                      <li>•	Historia Clínica completa foliada y fedateada del Asegurado, cuando la
                        compañía lo requiera.
                      </li>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del
                        Certificado de Invalidez Total y Permanente expedido por ESSALUD o la COMAFP (Comité Médico de las AFP) y/o COMEC (Comité Médico de la Superintendencia) o en su defecto por los hospitales nacionales bajo la gestión del MINSA o por el Instituto Nacional de Rehabilitación.
                      </li>
                    </ul>
                    Para INVALIDEZ TOTAL Y PERMANENTE POR ACCIDENTE:
                    <br /> Adicional a los Documentos Sustentatorios para la Cobertura de Invalidez Total y Permanente por Enfermedad, deberán presentar los siguientes documentos:

                    <ul>
                      <li>•	Original y/ certificación de reproducción notarial (copia legalizada) del</li>
                      <li>•	Atestado Policial o Parte Policial, según corresponda.</li>
                      <li>•	Original y/o certificación de reproducción notarial (copia legalizada) del resultado de examen toxicológico y dosaje etílico, en caso corresponda.</li>
                    </ul>
                    En caso de Siniestros en el extranjero, los documentos deberán estar legalizados por el Consulado Peruano del país donde ocurrió el siniestro y validado por el Ministerio de Relaciones Exteriores de Perú; o de ser el caso, debidamente apostillados.
                    <br />En caso los documentos estén en idioma extranjero, deberán presentarse con traducción oficial y visado por el Ministerio de Relaciones Exteriores.

                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="36">
                  <Accordion.Header>
                    ¿Mi vehículo queda en garantía una vez Adjudicado?
                  </Accordion.Header>
                  <Accordion.Body>
                    Efectivamente, una vez que hayas firmado el Contrato de Garantía Mobiliaria y Escritura Pública, la garantía del vehículo quedará inscrito en el Registro Mobiliario de Contratos de la Superintendencia Nacional de Registros Públicos (SUNARP).
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="37">
                  <Accordion.Header>
                    ¿Qué sucede si no pago mis cuotas antes de la adjudicación?
                  </Accordion.Header>
                  <Accordion.Body>
                    La EAFC resolverá unilateralmente el Contrato ante el incumplimiento del Asociado en el pago de tres (03) Cuotas Total consecutivas y las cuotas impagas estarán afectas a la Compensación por pago tardío especificado en el Tarifario. Para más información ver el  <a
                      href="/contactanos "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contrato de Administración de Fondos Colectivos
                    </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="38">
                  <Accordion.Header>
                    ¿Qué sucede si no pago mis cuotas después de la adjudicación?
                  </Accordion.Header>
                  <Accordion.Body>
                    La EAFC resolverá unilateralmente el Contrato ante el incumplimiento del Asociado en el pago de tres (03) Cuotas Total consecutivas e iniciará el proceso de Incautación del Vehículo. Para más información ver el  <a
                      href="/contactanos "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contrato de Administración de Fondos Colectivos
                    </a>
                    y el  <a
                      href="/contactanos "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contrato de Garantía Mobiliaria                  </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="39">
                  <Accordion.Header>
                    ¿Qué quiere decir que me han Resuelto el Contrato?
                  </Accordion.Header>
                  <Accordion.Body>
                    Si se tratara de un Asociado no adjudicado, tendrá derecho a la devolución de las Cuotas Capital aportadas, deduciendo las penalidades pactadas en el Contrato. Para ello, participarán en sorteos trimestrales que les permitirán, de ser beneficiados, obtener la devolución. De lo contrario, la devolución se efectuará una vez que finalice el plazo del Grupo del que formó parte el Asociado con Contrato resuelto.
                    <br />Si se tratara de un Asociado con bien entregado y/o servicio prestado, la EAFC podrá dar por vencidos los plazos pactados en el Contrato y exigir el pago de las Cuotas Total devengadas y por devengar hasta la finalización del Contrato. La EAFC podrá ejecutar las garantías otorgadas por el Asociado, salvo que se haya contratado un seguro de incumplimiento y este cubra el total de lo adeudado.

                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="40">
                  <Accordion.Header>
                    ¿Qué penalidades existen si me resuelven el Contrato?
                  </Accordion.Header>
                  <Accordion.Body>
                    Son las que están claramente establecidas en el Contrato, incluyendo el monto al que ascenderá. Ninguna penalidad de manera individual podrá superar el monto equivalente a dos (02) Cuotas Capitales.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="41">
                  <Accordion.Header>
                    ¿Qué ocurre si pago mis cuotas con atraso?
                  </Accordion.Header>
                  <Accordion.Body>
                    Las cuotas impagas estarán afectas a la Compensación por pago tardío especificado en el Tarifario. Para más información ver el  <a
                      href="/contactanos "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contrato de Administración de Fondos Colectivos
                    </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="42">
                  <Accordion.Header>
                    ¿Cómo es el proceso de devolución de aportes?
                  </Accordion.Header>
                  <Accordion.Body>
                    Si se tratara de un Asociado no adjudicado, tendrá derecho a la devolución de las Cuotas Capital aportadas, deduciendo las penalidades pactadas en el Contrato. Para ello, participarán en sorteos trimestrales que les permitirán, de ser beneficiados, obtener la devolución. De lo contrario, la devolución se efectuará una vez que finalice el plazo del Grupo del que formó parte el Asociado con Contrato resuelto.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="43">
                  <Accordion.Header>
                    ¿Dónde puedo consultar a la lista de Vendedores hábiles y aptos para ofrecer un Certificado de Compra?
                  </Accordion.Header>
                  <Accordion.Body>
                    Lo puedes revisar en nuestra web, en la sección de  <a
                      href="/transparencia "
                      className="linkturquesa "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Transparencia                 </a>
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="44">
                  <Accordion.Header>
                    Tengo otras dudas. ¿A qué número puedo llamar?
                  </Accordion.Header>
                  <Accordion.Body>
                    Puedes llamar a nuestro número de Atención al Cliente  (01) 730 - 1077.
                  </Accordion.Body>
                </Accordion.Item>
                <div className="section-information__tabs__link">
          <div className="section-information__tabs__link__body" onClick={() => setFaqVisable(false)} >
            <h6 >Ver menos preguntas</h6>
            <span>
              <img src="icons/safe/chevron-up-sm.svg" alt="Place Holder" />
            </span>
          </div>

        </div>
              </div>
            )
          }
        </Accordion>
      </div>
      )
    },
   
  ]

  const [animation, setAnimation] = useState('open')

  const isDesktop = useMediaQuery('(min-width: 1200px)');


  return (
    <div>

    {/*   <SurgirBanner
        showButton={false}
        textButton="Solicítalo ahora"
        title={'Auto Nuevo'}
        description={'Disfruta el proceso mientras te diriges hacia tu auto propio'}
        image={'Productos Auto nuevo banner.png'}
        showFooter={true}
        imageFooter={'logo-santander-gray.svg'}
        backgroundColor={'#F6FAFC'}
      /> */}
    <div className="boxi-s" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner"> Más cerca de tu <span style={{color:"#EC0000"}}>auto nuevo</span><br />
                <span className="banner-subText-banner">Disfruta el proceso mientras te diriges hacia tu auto propio.</span>
              </span>
              <br/>
              <span ><span className="text-respaldo" >Con el respaldo de {" "}</span></span>
              <img className="text-respaldo" style={{marginLeft:15}} src={`images/logos/logo-santander-gray.svg`}/>
            </div>
            <div>
              <img className="banner-image" src={bannerAuto} alt="Banner Donde Estamos" />
            </div>
          </div>
        </Container>

      </div>
      <div className="section-benefits">
        <Container>
          <div className="title-safe">
            Beneficios
          </div>

        </Container>

        <Container>
          <div className="section-benefits__cards">

            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={0}
              slidesPerView={3}
              navigation={isDesktop ? true : false}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 0
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 0
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 0
                },
                962: {
                  slidesPerView: 3,
                  spaceBetween: 0
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 0
                }
              }}
            >
              <SwiperSlide>
                <div className="section-benefits__cards__card">
                  <div>
                    <img src="images/safe/savings.svg" alt="Place Holder" />
                    <p>Pagas mucho menos que un crédito convencional</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="section-benefits__cards__card">
                  <div>
                    <img src="images/safe/hands-red.svg" alt="Place Holder" />
                    <p>Los fondos están supervisados por la SMV</p>
                  </div>

                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="section-benefits__cards__card">
                  <div>
                    <img src="images/safe/benefits-cuota-credito.svg" alt="Place Holder" />
                    <p>No afecta tu capacidad crediticia ante los bancos</p>
                  </div>
                </div></SwiperSlide>
              <SwiperSlide>
                <div className="section-benefits__cards__card">
                  <div>
                    <img src="images/safe/santander.svg" alt="Place Holder" />
                    <p>Tienes la solidez y respaldo del grupo Santander</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="section-benefits__cards__card">
                  <div>
                    <img src="images/safe/beneficio autos.png" alt="Place Holder" />
                    <p>Tenemos la más amplia variedad de marcas de vehículos para escoger</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

          </div>

        </Container>

      </div>

 

      <div className="section-operation">
        <Container>
          <div className="title-safe">
           ¿Cómo ingreso a Fondos Colectivos?
          </div>

          <div className="section-operation__body">
            <div className="section-operation__body__image">
              {
                mobile ?
                  <img src="images/safe/image-operation-mobile.png" alt="Place Holder" /> :
                  isTabletSm ?
                    <img src="images/safe/image-operation-mobile.png" alt="Place Holder" /> :
                    isTabletMd ?
                      <img src="images/safe/image-operation-mobile.png" alt="Place Holder" /> :
                      isTabletLg ?
                        <img src="images/safe/image-operation-mobile.png" alt="Place Holder" /> :
                        <img src="images/safe/image.png" alt="Place Holder" />
              }

            </div>


            <div className="section-operation__body__steppers">

              <ol>
                {
                  OPERATIONS.map((item, index) => {
                    return (
                      <li key={item.title}
                        className={"section-operation__body__steppers__item"}
                        data-content={index + 1}
                      >
                        <div className="section-operation__body__steppers__content">
                          <h5 className="section-operation__body__steppers__content__title">{item.title}</h5>
                          <h6 className="section-operation__body__steppers__content__description">{item.description}</h6>
                        </div>
                      </li>
                    )
                  })
                }
              </ol>
              <div style={{marginLeft:40}}>
            <SurgirButton
               onClick={requestContact}
               variant="danger"
               radius="24px"
               width={"223px"}
               height={"48px"}
               marginBottom={"0px"}
             
               marginTop={"20px"}
               fontFamily={"'SantanderTextW05-Bold', sans-serif"}
             
            >
             Contáctanos hoy
            </SurgirButton>
            </div>
       
            </div>

          </div>
        </Container>
      </div>

      <div className="section-protect">
        <Container>
          
          <div className="title-safe">
           
Escoge entre las marcas líderes del mercado

          </div>
          <center>
          <img className="safe-image-marcas" src={Marcas1} alt="Sorteo Esta Navidad SURGIR pone el regalo Banner Home" />
      
          
          </center>

        </Container>


     
      </div>

      <div className="section-information">
        <Container>
          <div className="title-safe">
            Entérate más sobre tu Auto Nuevo
          </div>

          {
            mobile || isTabletSm ?

              <div className="section-information__tabs-responsive">
                <SurgirTabsResponsive
                  tab={tabsResponsive}
                ></SurgirTabsResponsive>
              </div>
              :
              <div className="section-information__tabs">

                <Tabs
                  defaultActiveKey="Requisitos"
                  id="tabs"
                  style={{ marginBottom: "32px" }}
                >

                  {
                    tabsResponsive.map(item => {
                      return (
                        <Tab key={item.title} eventKey={item.title} title={item.title}>
                          {item.body}
                        </Tab>
                      )

                    })
                  }
                </Tabs>

              </div>
          }

        </Container>
      </div>

      <div className="section-contact">
        <Container>
          <div className="section-contact__body">
            <div className="section-contact__body__content">
              <div className="section-contact__body__content__title">
Simula tu financiamiento de auto nuevo</div>
              <p className="section-contact__body__content__description">Descubre cuánto podrás ahorrar</p>

              <div className="section-contact__body__content__description__phones d-flex">
              
                <div>
                <SurgirButton
               onClick={requestSimulator}
               variant="danger"
               radius="24px"
               width={"193px"}
               height={"48px"}
               marginBottom={"0px"}
               marginTop={"20px"}
               fontFamily={"'SantanderTextW05-Bold', sans-serif"}
             
            >
             Simula aquí
            </SurgirButton>
                </div>
              </div>
            </div>
            <div className="section-contact__body__image">
              <img alt='Contacto Mapfre Seguro Vida Place Holder SURGIR' src="images/safe/Productos Auto Nuevo banner simula v2.png" />
            </div>
          </div>
        </Container>
      </div>

    </div>
  );
};

export default Safe;









